import React, { useState,useEffect }from 'react';
import { OverlayTrigger, Tooltip} from 'react-bootstrap';
import VolumeWindow from '../Others/Volume.jsx';
import { Singleton } from '../../../js/Singleton.js';
import { useToasts, AgentButton } from 'global-components-library';
import { useDispatch,useSelector } from 'react-redux';
import { volumeMicrophone,volumeSpeaker } from '../../../redux/actions/A_volume.js';
import { setVolume } from '../../../redux/actions/A_preview.js';

const language = new Singleton();

const VolumeContainer = ({item,selectButton,mute, checkIsActiveButton}) => {
    const {selectedRecord:{callOutId, volume:{microphoneVol,speakerVol}}} = useSelector(state => state.preview);
    const [volumeSpeak, setVolumeSpeak] = useState(speakerVol);
    const [volumeMic,setVolumeMic] = useState(microphoneVol);
    const [newVolumeMic, setNewVolumeMic] = useState(microphoneVol);

    const { addToast } = useToasts();
    const dispatch = useDispatch();

    const alertError = () => {
      addToast(language.getText("GUIAlertVolumecontent"), {
        title: language.getText("GUIAlertVolumewarning"),
        group: 'icon', 
        position: 'topRight', 
        color: 'yellow', 
        btnComponent: <AgentButton type='tertiary'>{language.getText("GUIAlertMessageok")}</AgentButton>,
        timeout: 5000, 
      });
    };

    useEffect(() => {
      let temp= checkIsActiveButton('mute');
      setNewVolumeMic(volumeMic);
      if(temp){
        setVolumeMic(0);
      } else{
        setVolumeMic(newVolumeMic);
      }
    }, [mute]);

    useEffect(() => {
      setTimeout(() => {
        dispatch(setVolume({callOutId:callOutId,micVol:volumeMic,speakVol:volumeSpeak}))
        dispatch(volumeSpeaker(volumeSpeak));
        dispatch( volumeMicrophone(volumeMic));
      }, 50);
      let temp= checkIsActiveButton('mute');
      if(volumeMic > 0 && temp) 
      {
        selectButton("mute", false)
      }
      else if(volumeMic === 0 && !temp) 
      {
        selectButton("mute", true)
      }
    }, [volumeMic])
    

    const onChangeVolSpeak = vol =>{
      setVolumeSpeak(vol);
      dispatch(setVolume({callOutId:callOutId,micVol:volumeMic,speakVol:vol}))
    };

    const onChangeVolMic = vol => {
      dispatch(volumeMicrophone(vol));
      dispatch(setVolume({callOutId:callOutId,micVol:vol,speakVol:volumeSpeak}))
      setVolumeMic(vol)
    }
    
    
    
  return (
    <div className="volumeContainer" key={"buttonVolume"}>
      <OverlayTrigger
        id={`tlt-buttonsContainer-volumme`}
        key={`tlt-buttonsContainer-volumme`}
        placement="top"
        overlay={
          <Tooltip className="buttonsContainer-tooltip top show" id={`toolTiptlt-buttonsContainer-volumme`}>
            {language.getText(`GUICallSpace${item.tooltip}`)}
          </Tooltip>
        }
      >
        <div className={item.className} onClick={item.action}>
          {item.image}
        </div>
      </OverlayTrigger>
      {item.active && (
        <VolumeWindow
          volSpeaker={volumeSpeak}
          volMicrophone={volumeMic}
          muteMicrophone={volumeMic === 0}
          onChangeVolumeSpeakers={vol => onChangeVolSpeak(vol)}
          onChangeVolumeMicro={volume => onChangeVolMic(volume)}
          alert={e => alertError()}
          closeItem={()=>selectButton("volume", false)}
        />
      )}

    </div>
  )
}

export default VolumeContainer


// WEBPACK FOOTER //
// ./src/components/workSpace/SimultaneosRecsPreview/VolumeContainer.jsx